import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';

interface Update {
  id: string;
  title: string;
  description: string;
}

// HIER neue Features hinzufügen - diese Box wird dann automatisch angezeigt
const CURRENT_UPDATES: Update[] = [
  {
    id: 'update-metadaten-zeichenpruefung-20261103',
    title: '03.11.2026',
    description: 'Social-Media-Teaser, Meta-Titel und Meta-Beschreibung lassen sich jetzt nachträglich bearbeiten – auch nach einer fehlgeschlagenen Übertragung. Fehlende Meta-Angaben werden aus Artikeltitel und Untertitel vorbelegt. Bitte verzichte auf Emojis: Nicht unterstützte Zeichen werden vor dem Versand mit einem Hinweis auf das betroffene Feld gemeldet.'
  }
];

export const UpdatesBox: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4 shadow-sm">
      <div className="flex items-start">
        <SparklesIcon className="w-5 h-5 text-blue-600 mr-3 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <h3 className="text-base font-semibold text-blue-900 mb-2 flex items-center">
            Was gibt es Neues?
            <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
              Neu
            </span>
          </h3>
          <div className="space-y-2">
            {CURRENT_UPDATES.map((update) => (
              <div key={update.id} className="flex items-start">
                <span className="text-blue-600 mr-2 flex-shrink-0">•</span>
                <div>
                  <span className="text-sm font-medium text-gray-900">{update.title}:</span>
                  <span className="text-sm text-gray-700 ml-1">{update.description}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
